import React from "react";
import Navbar from "../components/Navbar";
import personImg from "../assets/images/accueil.png";

const Accueil = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="flex flex-col lg:flex-row items-center justify-between px-6 lg:px-20 gap-10 min-h-[calc(100vh-70px)] pt-3">
        {/* Image + formes */}
        <div className="relative w-full max-w-sm sm:max-w-md md:max-w-lg h-[420px] lg:left-20">
          {/* Formes géométriques - cachées sur petit écran */}
          <div className=" md:block absolute top-[120px] left-[-40px] w-[80px] h-[80px] bg-red-500 rotate-[-50deg] z-0 rounded-lg" />
          <div className=" md:block absolute top-[1px] right-[90px] w-[80px] h-[80px] bg-orange-500 rotate-[45deg] z-0 rounded-lg" />
          <div className=" md:block absolute bottom-[80px] left-[270px] w-[80px] h-[80px] bg-teal-600 rotate-[70deg] z-0 rounded-lg" />

          {/* Ombre */}
          <div className="absolute inset-0 max-w-[300px] shadow-3xl z-10 bg-white rounded-xl" />

          {/* Image */}
          <img
            src={personImg}
            alt="Bakeli Student"
            className="relative z-20 w-full h-full object-cover rounded-xl"
          />
        </div>

        {/* Texte + Boutons */}
        <div className="text-center md:text-left max-w-xl md:mr-6">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight text-black mb-4">
            BAKELI TRAINING <br />
            <span className="text-black">Explose tes limites</span>
          </h1>

          <p className="text-black font-extralight sm:text-lg md:text-xl leading-relaxed mt-4 max-w-md mx-auto md:mx-0 text-center md:text-start">
            Notre talent est de polir vos <br /> talents bruts, faire ressortir{" "}
            <br />
            tous ses éclats afin de faire <br /> ressortir tous ses éclats.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center lg:justify-start max-w-md mx-auto lg:mx-0 py-5">
            <button className="bg-[#FFA000] text-white font-bold text-base sm:text-lg py-3 rounded-md hover:bg-[#ff9500] transition w-full sm:w-40">
              Démarrer
            </button>
            <button className="bg-white text-[#FFA000] font-bold text-base sm:text-lg rounded-md border-2 border-[#FFA000] hover:bg-orange-50 transition w-full sm:w-40 text-black py-3">
              Infos
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accueil;
